import { useEffect, useRef, useState } from "react";
import { JJ_Icon_Chevron_down, JJ_Icon_Chevron_right } from "../../assets";

export const GMAF_TA_OPTIONS = [
    { key: "T1", label: "Autoantibody-Neuroimmunology" },
    { key: "T2", label: "Cardiovascular" },
    { key: "T16", label: "Closed Programs" },
    { key: "T3", label: "Dermatology" },
    { key: "T4", label: "Gastroenterology" },
    { key: "T5", label: "Neuro-Mood" },
    { key: "T6", label: "Neuro-Schizophrenia" },
    { key: "T7", label: "Neuro-Psychiatry" },
    { key: "T8", label: "Neuro-Neurodegeneration" },
    { key: "T18", label: "Neuro-Intra-Cellular" },
    { key: "T9", label: "Oncology-Genitourinary" },
    { key: "T10", label: "Oncology-Head & Neck Cancer" },
    { key: "T11", label: "Oncology-Hematology" },
    { key: "T12", label: "Oncology-Laboratory Science Liaisons" },
    { key: "T13", label: "Oncology-Lung" },
    { key: "T17", label: "Ophthalmology" },
    { key: "T14", label: "Respiratory" },
    { key: "T15", label: "Rheumatology" },
];

export const GMAF_CONTENT_SUBTYPES = [
    {
        key: "S1",
        label: "Core Assets (MCET Style)",
        assetTypes: [
            { key: "C1", label: "Core Clinical data" },
            { key: "C2", label: "Core Disease state | MOD" },
            { key: "C3", label: "Core Guideline" },
            { key: "C4", label: "Core MOA" },
            { key: "C5", label: "Core Pharmacoeconomics" },
            { key: "C6", label: "Core Pipeline" },
            { key: "C7", label: "Core Prescribing information" },
            { key: "C8", label: "Core RWE" },
            { key: "C9", label: "Core Safety | AE" },
            { key: "C10", label: "Core Treatment landscape" },
            { key: "C11", label: "Core Unmet needs" },
        ],
    },
    {
        key: "S2",
        label: "Core Assets (Pre-MCET Style)",
        assetTypes: [
            { key: "C12", label: "Core Clinical data" },
            { key: "C13", label: "Core Disease state | MOD" },
            { key: "C14", label: "Core Guideline" },
            { key: "C15", label: "Core MOA" },
            { key: "C16", label: "Core Pharmacoeconomics" },
            { key: "C17", label: "Core Pipeline" },
            { key: "C18", label: "Core Prescribing information" },
            { key: "C19", label: "Core RWE" },
            { key: "C20", label: "Core Safety | AE" },
            { key: "C21", label: "Core Treatment landscape" },
            { key: "C22", label: "Core Unmet needs" },
        ],
    },
    {
        key: "S3",
        label: "Strategic Sources",
        assetTypes: [
            { key: "C23", label: "Core Asset Themes (CATS)" },
            { key: "C24", label: "Scientific Communication Platforms" },
            { key: "C25", label: "ACE Launch Presentations" },
            { key: "C26", label: "Lexicons" },
        ],
    },
    {
        key: "S4",
        label: "Plans",
        assetTypes: [
            { key: "C27", label: "Publication Plans" },
            { key: "C28", label: "Medical Content Plans" },
            { key: "C29", label: "Annual External Engagement Plans" },
        ],
    },
    {
        key: "S5",
        label: "Training & Education",
        assetTypes: [
            { key: "C30", label: "WISE" },
            { key: "C31", label: "Congress Materials" },
            { key: "C32", label: "One Congress Voice" },
            { key: "C33", label: "FAQ" },
            { key: "C34", label: "Multimedia Assets" },
            { key: "C35", label: "Training Materials" },
            { key: "C36", label: "Bibliography" },
        ],
    },
    { key: "S6", label: "Other", assetTypes: [] },

    // {
    //     key: "mcetCoreAssets",
    //     label: "MCET Core Assets",
    //     secondaries: [
    //         "Disease state/MOD",
    //         "MOA",
    //         "Clinical Trial data (incl. post-hocs)",
    //         "Pipeline",
    //         "Safety / AE",
    //         "Unmet Need (> 18m)",
    //     ],
    // },
    // {
    //     key: "strategicSources",
    //     label: "Strategic Sources",
    //     secondaries: [
    //         "CATs (Core Asset Themes)",
    //         "Scientific Communication Platform",
    //         "Lexicon/Bibliography",
    //     ],
    // },
    // {
    //     key: "plans",
    //     label: "Plans",
    //     secondaries: [
    //         "Medical Content Plans",
    //         "External Engagement Plans",
    //         "Publication Plans",
    //     ],
    // },
    // {
    //     key: "trainingEducation",
    //     label: "Training/Education Content",
    //     secondaries: [
    //         "One Congress Voice",
    //         "WISE Decks",
    //         "Congress Decks",
    //         "FAQ",
    //         "Training Decks",
    //         "Channel Pieces (Videos, infographics)",
    //     ],
    // },
];

export const GMAF_DUMMY_PRODUCTS = [
    "Akeega",
    "Acuvue",
    "Balversa",
    "Darzalex",
    "Erleada",
    "Imbruvica",
    "Remicade",
    "Spravato",
    "Stelara",
    "Tremfya",
    "Xarelto",
];

export const getGMAFBranchKey = (ta, categoryKey) =>
    `${ta}::${categoryKey}`;

export const getGMAFTALabel = (taKey) =>
    GMAF_TA_OPTIONS.find((ta) => ta.key === taKey)?.label || taKey;

export const getGMAFSubtypeValue = (subtype, assetType) =>
    assetType?.key || subtype.key;

export const getGMAFSubtypeValues = (subtype) =>
    (subtype.assetTypes.length > 0 ? subtype.assetTypes : [null]).map(
        (assetType) => getGMAFSubtypeValue(subtype, assetType)
    );

export const getGMAFSelectedSubtypePaths = (selectedSubtypes) =>
    GMAF_CONTENT_SUBTYPES.flatMap((subtype) => {
        if (subtype.assetTypes.length === 0) {
            return selectedSubtypes.includes(subtype.key) ? [subtype.key] : [];
        }

        const allAssetTypesSelected = subtype.assetTypes.every((assetType) =>
            selectedSubtypes.includes(getGMAFSubtypeValue(subtype, assetType))
        );

        if (allAssetTypesSelected) {
            return [subtype.key];
        }

        return subtype.assetTypes
            .filter((assetType) =>
                selectedSubtypes.includes(getGMAFSubtypeValue(subtype, assetType))
            )
            .map((assetType) => `${subtype.key}/${assetType.key}`);
    });

const Chevron = ({ expanded, onClick }) => (
    <img
        className="gen-ai-ims-home-contentshortcut-div-inside-img"
        onClick={onClick}
        src={expanded ? JJ_Icon_Chevron_down : JJ_Icon_Chevron_right}
        alt={expanded ? "Collapse" : "Expand"}
    />
);

const GMAFTAFilter = ({
    taExpanded,
    expandedTAs,
    expandedAssetCategories,
    selectedTAs,
    selectedAssetCategories,
    selectedAssetTypes,
    onAllTAsChange,
    onTAChange,
    onToggleTA,
    onAssetCategoryChange,
    onToggleAssetCategory,
    onAssetTypeChange,
    onToggleTASection,
    popoverClassName = "",
}) => {
    const allTAsSelected = GMAF_TA_OPTIONS.every((ta) =>
        selectedTAs.includes(ta.key)
    );
    const someTAsSelected = GMAF_TA_OPTIONS.some((ta) =>
        selectedTAs.includes(ta.key)
    );
    const checkboxClassName = `gmaf-checkbox ${popoverClassName}`.trim();

    return (
        <div className="gmaf-primary-category">
            <div className="gmaf-primary-row">
                <label className="gmaf-checkbox-label">
                    <span className="gmaf-checkbox-text gmaf-primary-label">* TA is a required field</span>
                </label>
            </div>
            <div className="gmaf-primary-row">
                <label className="gmaf-checkbox-label">
                    <input
                        type="checkbox"
                        className={checkboxClassName}
                        checked={allTAsSelected}
                        ref={(element) => {
                            if (element) {
                                element.indeterminate = someTAsSelected && !allTAsSelected;
                            }
                        }}
                        onChange={onAllTAsChange}
                    />
                    <span className="gmaf-checkbox-text gmaf-primary-label">TA</span>
                </label>
                <Chevron expanded={taExpanded} onClick={onToggleTASection} />
            </div>

            {taExpanded && (
                <div className="gmaf-secondary-list">
                    {GMAF_TA_OPTIONS.map((ta) => {
                        return (
                            <div key={ta.key} className="gmaf-primary-category">
                                <div className="gmaf-primary-row">
                                    <label className="gmaf-checkbox-label">
                                        <input
                                            type="checkbox"
                                            className={checkboxClassName}
                                            checked={selectedTAs.includes(ta.key)}
                                            onChange={() => onTAChange(ta.key)}
                                        />
                                        <span className="gmaf-checkbox-text">{ta.label}</span>
                                    </label>
                                    {/* <Chevron
                                        expanded={isTAExpanded}
                                        onClick={() => onToggleTA(ta)}
                                    /> */}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export const GMAFContentSubtypeFilter = ({
    expandedSubtypes,
    selectedSubtypes,
    onAllSubtypesChange,
    onPrimarySubtypeChange,
    onSecondarySubtypeChange,
    onToggleSubtype,
    popoverClassName = "",
}) => {
    const allAssetTypes = GMAF_CONTENT_SUBTYPES.flatMap(
        getGMAFSubtypeValues
    );
    const allSelected = allAssetTypes.every((secondary) =>
        selectedSubtypes.includes(secondary)
    );
    const someSelected = allAssetTypes.some((secondary) =>
        selectedSubtypes.includes(secondary)
    );
    const checkboxClassName = `gmaf-checkbox ${popoverClassName}`.trim();

    return (
        <div className="gmaf-primary-category">
            <div className="gmaf-primary-row">
                <label className="gmaf-checkbox-label">
                    <input
                        type="checkbox"
                        className={checkboxClassName}
                        checked={allSelected}
                        ref={(element) => {
                            if (element) {
                                element.indeterminate = someSelected && !allSelected;
                            }
                        }}
                        onChange={onAllSubtypesChange}
                    />
                    <span className="gmaf-checkbox-text gmaf-primary-label">
                        Content Subtype
                    </span>
                </label>
            </div>

            <div className="gmaf-secondary-list">
                {GMAF_CONTENT_SUBTYPES.map((subtype) => {
                    const isExpanded = !!expandedSubtypes[subtype.key];
                    const subtypeValues = getGMAFSubtypeValues(subtype);
                    const allSubtypeSelected = subtypeValues.every((secondary) =>
                        selectedSubtypes.includes(secondary)
                    );
                    const someSubtypeSelected = subtypeValues.some((secondary) =>
                        selectedSubtypes.includes(secondary)
                    );

                    return (
                        <div key={subtype.key} className="gmaf-primary-category">
                            <div className="gmaf-primary-row">
                                <label className="gmaf-checkbox-label">
                                    <input
                                        type="checkbox"
                                        className={checkboxClassName}
                                        checked={allSubtypeSelected}
                                        ref={(element) => {
                                            if (element) {
                                                element.indeterminate =
                                                    someSubtypeSelected && !allSubtypeSelected;
                                            }
                                        }}
                                        onChange={() => onPrimarySubtypeChange(subtype)}
                                    />
                                    <span className="gmaf-checkbox-text gmaf-primary-label">
                                        {subtype.label}
                                    </span>
                                </label>
                                {subtype.assetTypes.length > 0 && (
                                    <Chevron
                                        expanded={isExpanded}
                                        onClick={() => onToggleSubtype(subtype.key)}
                                    />
                                )}
                            </div>

                            {isExpanded && subtype.assetTypes.length > 0 && (
                                <div className="gmaf-secondary-list">
                                    {subtype.assetTypes.map((secondary) => (
                                        <label
                                            key={secondary.key}
                                            className="gmaf-checkbox-label gmaf-secondary-item"
                                        >
                                            <input
                                                type="checkbox"
                                                className={checkboxClassName}
                                                checked={selectedSubtypes.includes(
                                                    getGMAFSubtypeValue(subtype, secondary)
                                                )}
                                                onChange={() =>
                                                    onSecondarySubtypeChange(subtype, secondary)
                                                }
                                            />
                                            <span className="gmaf-checkbox-text">{secondary.label}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export const GMAFProductMultiSelect = ({
    selectedProducts,
    onProductChange,
    GMAFProducts = [],
    popoverClassName = "",

}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const optionsRef = useRef(null);
    const availableProducts = GMAFProducts.filter(
        (product) =>
            !selectedProducts.includes(product) &&
            product.toLowerCase().includes(searchText.trim().toLowerCase())
    );

    useEffect(() => {
        if (isOpen) {
            optionsRef.current?.scrollIntoView({ block: "nearest" });
        }
    }, [isOpen]);

    const selectProduct = (product) => {
        onProductChange(product);
        setSearchText("");
        setIsOpen(false);
    };

    return (
        <div
            className={`gmaf-product-select ${popoverClassName}`.trim()}
            onBlur={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                    setIsOpen(false);
                }
            }}
        >
            {selectedProducts.length > 0 && (
                <div className="gmaf-product-chips">
                    {selectedProducts.map((product) => (
                        <span key={product} className="gmaf-product-chip popoverAvoidClickOutside">
                            {product}
                            <button
                                type="button"
                                className="gmaf-product-remove popoverAvoidClickOutside"
                                aria-label={`Remove ${product}`}
                                onClick={() => onProductChange(product)}
                            >
                                &times;
                            </button>
                        </span>
                    ))}
                </div>
            )}

            <div className="gmaf-checkbox-text gmaf-primary-label">
                Product Name (Optional)
            </div>
            <div className="gmaf-product-combobox">
                <input
                    type="text"
                    className={`gmaf-product-input ${popoverClassName}`.trim()}
                    value={searchText}
                    placeholder="Filter by product name (Optional)"
                    autoComplete="off"
                    aria-label="Filter by product name (Optional)"
                    role="combobox"
                    aria-autocomplete="list"
                    aria-controls="gmaf-product-options"
                    aria-expanded={isOpen}
                    onChange={(event) => {
                        const value = event.target.value;
                        setSearchText(value);
                        setIsOpen(value.trim().length >= 1);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === "Escape") setIsOpen(false);
                    }}
                />

                {isOpen && (
                    <div
                        ref={optionsRef}
                        id="gmaf-product-options"
                        className="gmaf-product-options"
                        role="listbox"
                    >
                        {availableProducts.length > 0 ? (
                            availableProducts.map((product) => (
                                <button
                                    key={product}
                                    type="button"
                                    role="option"
                                    aria-selected="false"
                                    className={`gmaf-product-option ${popoverClassName}`.trim()}
                                    onClick={() => selectProduct(product)}
                                >
                                    <span aria-hidden="true">+</span> {product}
                                </button>
                            ))
                        ) : (
                            <div className="gmaf-product-empty">No matching products</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GMAFTAFilter;